module.exports = __webpack_public_path__ + "img/equipe.e13a738f.svg";